import { render, staticRenderFns } from "./coupon-add-or-update.vue?vue&type=template&id=6f8707ee&"
import script from "./coupon-add-or-update.vue?vue&type=script&lang=js&"
export * from "./coupon-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports